import Vue from 'vue';

const success = (data, resolve) => {
  resolve(data);
};

const failed = (errors, reject) => {
  reject(errors);
};

export default action => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('subscriberList/subscriberSwitch/all', action)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/subscriber/subscribeSwitchAll.js